import React from 'react';
import Profile from "../Profile";
import AddCommentProfile from "./AddCommentProfile";
import MyCommentsProfile from "./MyCommentsProfile";

const Comments = () => {
    return (
        <div className="comments-profile-wrapper">
            <Profile/>
            <div className="container container-comments">
                <div className="comments-tab xmb-lg-6">
                    <ul className="nav nav-tabs" id="tab-comments"
                        role="tablist">
                        <li className="nav-item" role="presentation">
                            <div className="nav-link active" id="nav-submit-comment-tab"
                                 data-bs-toggle="tab"
                                 data-bs-target="#nav-submit-comment" role="tab"
                                 aria-controls="nav-submit-comment" aria-selected="true">
                                <span className="text">ثبت نظر</span>
                                <span className="number persian-number">4</span>
                            </div>
                        </li>
                        <li className="nav-item" role="presentation">
                            <div className="nav-link" id="nav-my-comments-tab"
                                 data-bs-toggle="tab"
                                 data-bs-target="#nav-my-comments" role="tab"
                                 aria-controls="nav-my-comments" aria-selected="true">
                                <span className="text">نظرات من</span>
                                <span className="number persian-number">6</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="tab-content" id="nav-comments">
                    <div className="tab-pane fade show active" id="nav-submit-comment"
                         role="tabpanel" aria-labelledby="nav-submit-comment-tab">
                        <AddCommentProfile/>
                    </div>
                    <div className="tab-pane fade show" id="nav-my-comments"
                         role="tabpanel" aria-labelledby="nav-my-comments-tab">
                        <MyCommentsProfile/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Comments;
